import React from 'react';
import { TextField, Autocomplete } from '@mui/material';
import IconPopup from '../help-icon-popup';

export default ({
  value, onChange = (e) => e, label = '', error = '', helpText, options, style = {}, freeSolo, info, ...props
}) => {
  let helpSection = error;

  if (!!helpText && !error) {
    helpSection = (
      <>
        {helpText}
        {info && <IconPopup content={info} />}
      </>
    );
  }

  return (
    <Autocomplete
      options={options}
      freeSolo={freeSolo}
      getOptionLabel={(option) => option.toString()}
      style={{
        ...style,
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          margin="normal"
          variant="outlined"
          fullWidth
          value={(value || value === 0) ? value : null}
          onChange={(e) => onChange(e.target.value)}
          error={!!error}
          helperText={helpSection}
          InputLabelProps={{ shrink: !!props.placeholder }}
          {...props}
        />
      )}
    />
  );
};
